export function createProjectService() {
  let projectId = "";

  document.addEventListener("hydrotools:project-changed", (e) => {
    projectId = String(e.detail?.projectId || "").trim();
  });

  return {
    getProjectId: () => projectId,
  };
}
